import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";

const initialState = {
  productListNew:{
    items: [],
    total: 0,        
    current_page: 0, 
    page_size: 0,    
  },
  productList: {
    items: [],
    total: 0,        
    current_page: 0, 
    page_size: 0,    
  },
  filters: {},
  status: "idle", 
  loadingMore: false, 
  error: null,
  filtersStatus: "idle", 
};

export const getProducts = createAsyncThunk(
  "shop/getProducts",
  async ({ filters, page }, thunkAPI) => {
    try {
      const { data } = await axiosClient.get("search/products", {
        params: { ...filters,page : page},
      });
      return data?.success ? data.data : thunkAPI.rejectWithValue("Error fetching products");
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error fetching products");
    }
  }
);

export const getProductsNew = createAsyncThunk(
  "shop/getProductsNew",
  async ({ filters, page }, thunkAPI) => {
    try {
      const { data } = await axiosClient.get("search/products", {
        params: { ...filters},
      });
      return data?.success ? data.data : thunkAPI.rejectWithValue("Error fetching products");
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error fetching products");
    }
  }
);

export const getFilters = createAsyncThunk(
  "shop/getFilters",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosClient.get("search/filters");
      return data?.success ? data.data : thunkAPI.rejectWithValue("Error fetching filters");
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error fetching filters");
    }
  }
);

const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    clearProducts(state) {
      state.productListNew.items = [];
      state.productListNew.total = 0;
      state.productListNew.current_page = 0;
      state.productList.items = [];
      state.productList.total = 0;
      state.productList.current_page = 0;
      state.status = "idle";
      state.loadingMore = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state, action) => {
        state.error = null;
        if (action.meta.arg.page === 1) {
          state.status = "loading";
        } else {
          state.loadingMore = true; 
        }
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        const { items, total, page_size, current_page } = action.payload; 
        const requestedPage = action.meta.arg.page;
        
        if (requestedPage === 1) {
          state.productList.items = items;
          state.status = "succeeded";
        } else {
          state.productList.items = [...state.productList.items, ...items];
          state.loadingMore = false;
        }
        
        state.productList.total = total;
        state.productList.page_size = page_size;
        state.productList.current_page = current_page;
      })
      .addCase(getProducts.rejected, (state, action) => {
        if (action.meta.arg.page === 1) {
          state.status = "failed";
        } else {
          state.loadingMore = false;
        }
        state.error = action.payload;
      })

      .addCase(getFilters.pending, (state) => {
        state.filtersStatus = "loading";
      })
      .addCase(getFilters.fulfilled, (state, action) => {
        state.filtersStatus = "succeeded";
        state.filters = action.payload.filters; 
      })
      .addCase(getFilters.rejected, (state, action) => {
        state.filtersStatus = "failed";
        state.error = action.payload;
      })
        .addCase(getProductsNew.pending, (state, action) => {
        state.error = null;
        if (action.meta.arg.page === 1) {
          state.status = "loading";
        } else {
          state.loadingMore = true; 
        }
      })
      .addCase(getProductsNew.fulfilled, (state, action) => {
        const { items, total, page_size, current_page } = action.payload; 
        const requestedPage = action.meta.arg.page;
        
        if (requestedPage === 1) {
          state.productListNew.items = items;
          state.status = "succeeded";
        } else {
          state.productListNew.items = [ ...items];
          state.loadingMore = false;
        }
        
        state.productListNew.total = total;
        state.productListNew.page_size = page_size;
        state.productListNew.current_page = current_page;
      })
      .addCase(getProductsNew.rejected, (state, action) => {
        if (action.meta.arg.page === 1) {
          state.status = "failed";
        } else {
          state.loadingMore = false;
        }
        state.error = action.payload;
      })
  },
});

export const { clearProducts } = shopSlice.actions;
export default shopSlice.reducer;